import { Component, Inject, OnInit } from '@angular/core';
import { SESSION_STORAGE, StorageService } from 'ngx-webstorage-service';
import { ApiService } from 'src/app/api.service';
import { ExportToCsv } from 'export-to-csv';
import { ElementSchemaRegistry } from '@angular/compiler';
import { DatePipe } from '@angular/common'


@Component({
  selector: 'app-admin-report',
  templateUrl: './admin-report.component.html',
  styleUrls: ['./admin-report.component.css'],
  providers: [DatePipe]
})
export class AdminReportComponent implements OnInit {

  show_loader = false;
  timeLeft: number = 5;
  interval;

  Report_CustDetials: any = [];
  CustumDtails: any = [];
  FollowUpList: any = [];
  PaymentsList: any;
  SettlementList: any;
  FieldvisitList: any;
  bankList: any = [];
  portfolioList: any;
  bucketList: any = [];
  searchLoaded: boolean;
  portfolioid: any;
  bucketid: any;
  bankid: any;
  bank_name: any;

  date_search: any;
  start_date: any;
  end_date: any;
  text_search: any;
  agent_search: any = '';
  userFilter: any = { log_date: '', agent_name: '' };

  temp_data = [];
  user_list = [];

  payment_count = 10;
  payment_skip = 0;
  payment_text_search = '';
  payment_date_search = '';



  ptp_start_date = '';
  ptp_end_date = '';

  payment_start_date = '';
  payment_end_date = '';

  error_msg = '';
  settlementList: any;
  settlementAndPaymentList: any;
  shortBaseReportList: any;
  baseReportBankList: any;
  fieldVisitReportList: any;
  remarks: any;


  sortField = '';
  sortOrder = 'asc';
  sortIconClass = 'fa-sort';

  sortRemarksByDate(item: any[]): any[] {
    return item.sort((a, b) => {
      const dateA = new Date(a.createdAtString).getTime();
      const dateB = new Date(b.createdAtString).getTime();
      return dateA - dateB;
    });
  }

  getFormattedDate(createdAt: string): string {
    const date = new Date(createdAt);
    const dateString = date.toISOString().substring(0, 10);
    return dateString;
  }
  constructor(public datepipe: DatePipe, private _api: ApiService, @Inject(SESSION_STORAGE) private storage: StorageService,) { }


  ngOnInit(): void {
    this.error_msg = '';
    this.searchLoaded = false;

    let a = {
      client_id: this.getFromLocal('Client_ID'),
    }
    this._api.getlist_bank_details(a).subscribe(data => {
      if (data['Code'] == 200) {
        this.bankList = [];
        console.log(this.bankList);
        let login_Details = this.getFromLocal("login_Details");
        console.log(login_Details);
        if (login_Details.designation !== 'Admin') {
          if (login_Details.selected_portfolio_list.length == 0) {
            this.error_msg = 'true';
            this.bankList = [];
          } else {
            let temp = [];
            login_Details.selected_portfolio_list.forEach(element => {
              temp.push(element.bank_id);
            });
            var uniqueArray = removeDuplicates(temp, "bank_name");
            console.log(uniqueArray);
            this.bankList = uniqueArray;
            function removeDuplicates(originalArray, prop) {
              var newArray = [];
              var lookupObject = {};
              for (var i in originalArray) {
                lookupObject[originalArray[i][prop]] = originalArray[i];
              }
              for (i in lookupObject) {
                newArray.push(lookupObject[i]);
              }
              return newArray;
            }
          }
        } else {
          this.bankList = data['Data'];
        }

      } else {

        this.bankList = [];
      }
    });







    this._api.user_details_list().subscribe(
      (response: any) => {
        this.user_list = response.Data;
        // let list = response.Data.reverse();
        // for (let i = 0; i < list.length; i++) {
        //   let obj = { "y": list[i].portfolio_type};
        //   this.portfolio_list.push(obj);
        // }
        // this.booleans = true;
      }
    );




    this._api.portfolio_type_list(a).subscribe(data => {
      if (data['Code'] == 200) {
        this.portfolioList = data['Data']
      } else {
        this.portfolioList = [];
      }
    });


    this._api.getBucketList().subscribe(data => {
      if (data['Code'] == 200) {
        this.bucketList = data['Data'];
      } else {
        this.bucketList = [];
      }
    });

    // const dataFormat = {
    //   bank_id : "6087fe7a8dc51d0eb6dcdd6b",
    //   bucket_id : "6087fe7a8dc51d0eb6dcdd6b",
    //   portfolio_id : "6087fe7a8dc51d0eb6dcdd6b",
    //   product_id : "6087fe7a8dc51d0eb6dcdd6b"
    // }

    // this._api.getFollowUpReport(dataFormat).subscribe(data=>{
    //   if (data['Code']==200) {
    //     this.FollowUpList = data['Data'];
    //   } else {
    //     this.FollowUpList = [];
    //   }
    // });


    // this._api.getPaymentsReport(dataFormat).subscribe(data=>{
    //   if (data['Code']==200) {
    //     this.PaymentsList = data['Data'];
    //   } else {
    //     this.PaymentsList = [];
    //   }
    // });

    // this._api.getSettlementsReport(dataFormat).subscribe(data=>{
    //   if (data['Code']==200) {
    //     this.SettlementList = data['Data'];
    //   } else {
    //     this.SettlementList = [];
    //   }
    // });

    // this._api.getFieldvisitReport(dataFormat).subscribe(data=>{
    //   if (data['Code']==200) {
    //     this.FieldvisitList = data['Data'];
    //   } else {
    //     this.FieldvisitList = [];
    //   }
    // });

  }


  fetchuser_1() {
    let a = {
      client_id: this.getFromLocal("Client_ID"),
      bank_id: this.bankid
    }
    this._api.portfolio_type_list_bank_id(a).subscribe(
      (response: any) => {


        this.portfolioList = [];
        console.log(response.Data)
        let login_Details = this.getFromLocal("login_Details");
        if (login_Details.designation !== 'Admin') {
          let temp = login_Details.selected_portfolio_list;
          for (let a = 0; a < response.Data.length; a++) {
            for (let b = 0; b < temp.length; b++) {
              console.log(response.Data[a], temp[b]);
              if (response.Data[a]._id == temp[b]._id) {
                this.portfolioList.push(response.Data[a])
              }
            }
          }
        } else {
          this.portfolioList = response['Data'];
        }
        console.log(this.portfolioList);
      }
    );
  }

  getFromLocal(key): any {
    return this.storage.get(key);
  }


  search() {
    this.startTimer();
    const dataFormat = {
      bank_id: this.bankid,
      bucket_id: this.bucketid || "",
      portfolio_id: this.portfolioid,
      product_id: "1",
      skip: this.payment_skip,
      count: 10,
    };

    // console.log(dataFormat);

    // this._api.getFollowUpReport(dataFormat).subscribe(data => {
    //   if (data['Code'] == 200) {

    //     this.FollowUpList = data['Data'];
    //     this.temp_data = data['Data'];
    //     // console.log(this.FollowUpList);


    //     //  var temp = await data['Data'];
    //     this.FollowUpList = [];
    //     //  console.log(this.searchResults);
    //     let login_Details = this.getFromLocal("login_Details");
    //     var portfolio_list = login_Details.selected_portfolio_list;
    //     console.log(portfolio_list, "123456787");

    //     for (let a = 0; a < portfolio_list.length; a++) {
    //       this.temp_data.forEach(element => {
    //         // console.log(element.bank_id._id, portfolio_list[a].bank_id._id, 'test');
    //         if (element.bank_id._id == portfolio_list[a].bank_id._id) {
    //           // console.log("Data In");
    //           this.FollowUpList.push(element);
    //         }
    //       });
    //     }



    //     this.FollowUpList.forEach(element => {

    //       if (element.customer.customer_details[0].Customer_Name == undefined) {
    //         let name = JSON.parse(element.customer.customer_details[0]);
    //         element.customer_name = name[0].Customer_Name || '';
    //       } else {
    //         element.customer_name = element.customer.customer_details[0].Customer_Name || '';
    //       }

    //       element.agent_name = element.createdby.name;
    //     });



    //   } else {
    //     this.FollowUpList = [];
    //   }

    // });


    this._api.getPaymentsReport(dataFormat).subscribe(data => {
      if (data['Code'] == 200) {
        this.PaymentsList = [];
        this.payment_count = data['payment_count'];
        // console.log("payment_count",this.PaymentsList);
        this.temp_data = data['Data'];
        console.log(this.temp_data);
        let login_Details = this.getFromLocal("login_Details");
        var portfolio_list = login_Details.selected_portfolio_list;
        console.log(portfolio_list);
        for (let a = 0; a < portfolio_list.length; a++) {
          this.temp_data.forEach(element => {
            console.log(element.bank_id._id, portfolio_list[a].bank_id._id);
            if (element.bank_id._id == portfolio_list[a].bank_id._id) {
              // console.log("Data In");
              this.PaymentsList.push(element);
            }
          });
        }


        this.PaymentsList.forEach(element => {
          if (element.customer.customer_details[0].Customer_Name == undefined) {
            let name = JSON.parse(element.customer.customer_details[0]);
            element.customer_name = name[0].Customer_Name || '';
          } else {
            element.customer_name = element.customer.customer_details[0].Customer_Name || '';
          }
          //  element.agent_name = element.createdby.name;
        });

      } else {
        this.PaymentsList = [];
      }
    });

    this._api.getSettlementsReport(dataFormat).subscribe(data => {
      if (data['Code'] == 200) {
        this.SettlementList = data['Data'];
      } else {
        this.SettlementList = [];
      }
    });

    this._api.getFieldvisitReport(dataFormat).subscribe(data => {
      if (data['Code'] == 200) {
        this.FieldvisitList = data['Data'];
      } else {
        this.FieldvisitList = [];
      }
    });

    this.searchLoaded = true;
  }

  exportPTPreport() {
    this.FollowUpList && this.FollowUpList.forEach((element) => {
    const dateString =new Date(element.ptp_date);
    var dateOnly = dateString.toISOString().substring(0, 10); // Returns the date in the local date format
    element.ptp_date = dateOnly
    console.log("dateOnly", element.ptp_date);
    });

    const keyToRemove = "customer";
    const newArray =  this.FollowUpList.map(obj => {
      const newObj = {};
      Object.keys(obj).forEach(key => {
        if (key !== keyToRemove ) {
          newObj[key] = obj[key];
        }

      });
      return newObj;
    });
    console.log("newArray",newArray);
    const options = {
      filename: 'FollowUp_Report_' + new Date(),
      fieldSeparator: ',',
      quoteStrings: '"',
      decimalSeparator: '.',
      showLabels: true,
      showTitle: true,
      title: 'FollowUp_Report_' + new Date(),
      useTextFile: false,
      useBom: true,
      useKeysAsHeaders: true,
      // headers: ['Column 1', 'Column 2', etc...] <-- Won't work with useKeysAsHeaders present!
    };

    const csvExporter = new ExportToCsv(options);

    csvExporter.generateCsv(newArray);
  }


    exportSettlementreport() {
      const newArray = this.settlementList.map(obj => {
        const { customer,reportingtoDetail,Reporting_to_id_Detail,customer_name,bank_name,PaymentsInfoDetail,
          set_id,proposed_date,approval_status,details_notes,approved_date,status,createdby,requested_date,customer_id2,
          attachment_url,reportingto_id,bank_id,bucket_id,portfolio_id,product_id,updatedAt ,Member_user_id_Detail,approval_status2, ...rest } = obj;
        return rest;
      });

      const options = {
        filename: 'Settlement_Report_' + new Date(),
        fieldSeparator: ',',
        quoteStrings: '"',
        decimalSeparator: '.',
        showLabels: true,
        showTitle: true,
        title: 'Settlement_Report_' + new Date(),
        useTextFile: false,
        useBom: true,
        useKeysAsHeaders: true,
        // headers: ['Column 1', 'Column 2', etc...] <-- Won't work with useKeysAsHeaders present!
      };

      const csvExporter = new ExportToCsv(options);

      csvExporter.generateCsv(newArray);
    }

  exportPaymentsreport() {
    this.PaymentsList && this.PaymentsList.forEach((element) => {
      const dateString =new Date(element.payment_date);
      var dateOnly = dateString.toISOString().substring(0, 10); // Returns the date in the local date format
      element.payment_date = dateOnly
      console.log("dateOnly", element.payment_date);
      });
     const newArray = this.PaymentsList.map(obj => {
    const { customer,next_payment_date, ...rest } = obj;
    return rest;
  });

    const options = {
      filename: 'Payments_Report_' + new Date(),
      fieldSeparator: ',',
      quoteStrings: '"',
      decimalSeparator: '.',
      showLabels: true,
      showTitle: true,
      title: 'Payments_Report_' + new Date(),
      useTextFile: false,
      useBom: true,
      useKeysAsHeaders: true,
      // headers: ['Column 1', 'Column 2', etc...] <-- Won't work with useKeysAsHeaders present!
    };

    const csvExporter = new ExportToCsv(options);

    csvExporter.generateCsv(newArray);
  }

  exportFieldvisitreport() {
    const newArray = this.fieldVisitReportList.map(obj => {
      const { portfolio_typesDetail,
        bucketsDetails,
        addedByDetail,
        BankDetail,
        accountDetail,
        added_by,
        bank_id,
        bucket_id,
        customer_details,
        product_id,
        stop_follow_up_status,
        tem_fint_id,
        remarks,
        bucket,
        cycle,
        flow_status,
        nationality,
        product_name,
        status,
        mark_complete_status,
        porfolio_id,
        log_id,
        fieldvisitterritory,
        fieldvisitarea,
        firstaddress,
        secondaddress,
        createdby,
        creator_name,
        attachment_url,
        reportingto_id,
        assigned_coordinator,
        customer_id,
        client_id,
        portfolio_id,
        reportingtoDetail,
        Member_user_id_Detail,
        Reporting_to_id_Detail,
        customer_name,
        assigned_agent,
         ...rest } = obj;
      return rest;
    });
    const options = {
      filename: 'Fieldvisit_Report_' + new Date(),
      fieldSeparator: ',',
      quoteStrings: '"',
      decimalSeparator: '.',
      showLabels: true,
      showTitle: true,
      title: 'Fieldvisit_Report_' + new Date(),
      useTextFile: false,
      useBom: true,
      useKeysAsHeaders: true,
      // headers: ['Column 1', 'Column 2', etc...] <-- Won't work with useKeysAsHeaders present!
    };

    const csvExporter = new ExportToCsv(options);

    csvExporter.generateCsv(newArray);
  }


  exportReport_CustDetialsreport() {
    const newArray = this.Report_CustDetials.map(obj => {
      const { portfolio_typesDetail,
        bucketsDetails,
        addedByDetail,
        BankDetail,
        accountDetail,
        added_by,
        bank_id,
        bucket_id,
        customer_details,
        product_id,
        stop_follow_up_status,
        tem_fint_id,
        remarks,
        bucket,
        cycle,
        flow_status,
        nationality,
        product_name,
        status,
        mark_complete_status,
        porfolio_id,
         ...rest } = obj;
      return rest;
    });
    const options = {
      filename: 'Allocation_Report_' + new Date(),
      fieldSeparator: ',',
      quoteStrings: '"',
      decimalSeparator: '.',
      showLabels: true,
      showTitle: true,
      title: 'Allocation_Report_' + new Date(),
      useTextFile: false,
      useBom: true,
      useKeysAsHeaders: true,
      // headers: ['Column 1', 'Column 2', etc...] <-- Won't work with useKeysAsHeaders present!
    };

    const csvExporter = new ExportToCsv(options);

    csvExporter.generateCsv(newArray);
  }


  exportsettlementAndPaymentListreport() {
    const newArray = this.settlementAndPaymentList.map(obj => {
      const { customer,reportingtoDetail,Reporting_to_id_Detail,customer_name,bank_name,PaymentsInfoDetail,
        set_id,proposed_date,approval_status,details_notes,approved_date,status,createdby,requested_date,customer_id2,
        attachment_url,reportingto_id,bank_id,bucket_id,portfolio_id,product_id,Member_user_id_Detail,approval_status2, ...rest } = obj;
      return rest;
    });
    const options = {
      filename: 'settlementAndPayment_Report_' + new Date(),
      fieldSeparator: ',',
      quoteStrings: '"',
      decimalSeparator: '.',
      showLabels: true,
      showTitle: true,
      title: 'settlementAndPayment_Report_' + new Date(),
      useTextFile: false,
      useBom: true,
      useKeysAsHeaders: true,
      // headers: ['Column 1', 'Column 2', etc...] <-- Won't work with useKeysAsHeaders present!
    };

    const csvExporter = new ExportToCsv(options);

    csvExporter.generateCsv(newArray);
  }


  exportshortBaseReportListreport() {
    const newArray = this.shortBaseReportList.map(obj => {
      const { portfolio_typesDetail,
        bucketsDetails,
        addedByDetail,
        BankDetail,
        accountDetail,
        added_by,
        bank_id,
        bucket_id,
        customer_details,
        product_id,
        stop_follow_up_status,
        tem_fint_id,
        remarks,
        bucket,
        cycle,
        flow_status,
        nationality,
        product_name,
        status,
        mark_complete_status,
        porfolio_id,
        log_id,
        fieldvisitterritory,
        fieldvisitarea,
        firstaddress,
        secondaddress,
        createdby,
        creator_name,
        attachment_url,
        reportingto_id,
        assigned_coordinator,
        customer_id,
        client_id,
        portfolio_id,
        reportingtoDetail,
        Member_user_id_Detail,
        Reporting_to_id_Detail,
        customer_name,
        assigned_agent,
         ...rest } = obj;
      return rest;
    });
    const options = {
      filename: 'shortBaseList_Report_' + new Date(),
      fieldSeparator: ',',
      quoteStrings: '"',
      decimalSeparator: '.',
      showLabels: true,
      showTitle: true,
      title: 'shortBaseList_Report_' + new Date(),
      useTextFile: false,
      useBom: true,
      useKeysAsHeaders: true,
      // headers: ['Column 1', 'Column 2', etc...] <-- Won't work with useKeysAsHeaders present!
    };

    const csvExporter = new ExportToCsv(options);

    csvExporter.generateCsv(newArray);
  }

  exportCustumDtailsreport() {

    this.CustumDtails && this.CustumDtails.forEach((element) => {
        const output = element.remarks.map((obj, index) => {
          return (index + 1) + ". " + obj.remarks;
        }).join(", \n").trim("");
        const output2 = element.mstatus.map((obj, index) => {
          return (index + 1) + ". " + obj.mstatus;
        }).join(", \n").trim("");

        element.feedback=output
        element.mstatus = output2

    });
    console.log("this.CustumDtails",this.CustumDtails);

    const newArray = this.CustumDtails.map(obj => {
      const { portfolio_typesDetail,
        bucketsDetails,
        addedByDetail,
        BankDetail,
        accountDetail,
        added_by,
        bank_id,
        bucket_id,
        customer_details,
        product_id,
        stop_follow_up_status,
        tem_fint_id,
        bucket,
        cycle,
        flow_status,
        nationality,
        product_name,
        status,
        mark_complete_status,
        porfolio_id,
        remarks,
         ...rest } = obj;
      return rest;
    });
    const options = {
      filename: 'Feedback_Report_' + new Date(),
      fieldSeparator: ',',
      quoteStrings: '"',
      decimalSeparator: '.',
      showLabels: true,
      showTitle: true,
      title: 'Feedback_Report_' + new Date(),
      useTextFile: false,
      useBom: true,
      useKeysAsHeaders: true,
      // headers: ['Column 1', 'Column 2', etc...] <-- Won't work with useKeysAsHeaders present!
    };

    const csvExporter = new ExportToCsv(options);

    csvExporter.generateCsv(newArray);
  }

  exportbaseReportBankListreport() {
    const options = {
      filename: 'baseBankList_Report_' + new Date(),
      fieldSeparator: ',',
      quoteStrings: '"',
      decimalSeparator: '.',
      showLabels: true,
      showTitle: true,
      title: 'baseBankList_Report_' + new Date(),
      useTextFile: false,
      useBom: true,
      useKeysAsHeaders: true,
      // headers: ['Column 1', 'Column 2', etc...] <-- Won't work with useKeysAsHeaders present!
    };

    const csvExporter = new ExportToCsv(options);

    csvExporter.generateCsv(this.baseReportBankList);
  }


  datesearch() {
    // "2010-04-29T00:00:00.000Z"


    this.startTimer();
    let c = {
      bank_id: this.bankid,
      bucket_id: this.bucketid || "",
      portfolio_id: this.portfolioid,
      start_date: this.ptp_start_date + "T00:00:00.000Z",
      end_date: this.ptp_end_date + "T00:00:00.000Z",
      agent_name: this.agent_search
    }
    if (this.ptp_start_date == '' && this.ptp_end_date !== '') {
      alert("select start date");
    } else if (this.ptp_start_date !== '' && this.ptp_end_date == '') {
      alert("select end date");
    } else if (this.ptp_start_date !== '' && this.ptp_end_date !== '' && this.agent_search == '') {
      // console.log(c );
      this._api.getFollowUpReport_date(c).subscribe(data => {
        if (data['Code'] == 200) {
          this.FollowUpList = data['Data'];
          console.log("this.FollowUpList",this.FollowUpList);

          this.temp_data = data['Data'];
          this.FollowUpList.forEach(element => {
            let name = JSON.parse(element.customer);
            element.customer_name = name[0].Customer_Name || '';
            // element.cif = name[0].cif || '';
            element.agent_name = name[0].AGENT;
          });


          console.log(this.FollowUpList, '12345');
          if (this.agent_search) {
            this.FollowUpList = this.FollowUpList.filter((ele: any) =>
              ele.agent_name.toUpperCase() == this.agent_search.toUpperCase()
            )
          }
          console.log(this.FollowUpList, 'FollowUpList');


        } else {
          this.FollowUpList = [];
          this.temp_data = [];
        }
      });
    }
    else if (this.ptp_start_date == '' && this.ptp_end_date == '' && this.agent_search !== '') {
      this._api.getFollowUpReport_agent(c).subscribe(data => {
        if (data['Code'] == 200) {
          this.FollowUpList = data['Data'];
          this.temp_data = data['Data'];
          this.FollowUpList.forEach(element => {
            let name = JSON.parse(element.customer.customer_details[0]);
            element.customer_name = name[0].Customer_Name || '';
            element.agent_name = element.createdby.name;
            console.log(this.temp_data, '123');
            console.log(this.FollowUpList, '123');

          });
        } else {
          this.FollowUpList = [];
          this.temp_data = [];
        }


      });
    }
    else if (this.ptp_start_date !== '' && this.ptp_end_date !== '' && this.agent_search !== '') {
      this._api.getFollowUpReport_all(c).subscribe(data => {
        if (data['Code'] == 200) {

          this.FollowUpList = data['Data'];
          console.log("FollowUpList",this.FollowUpList);
          this.temp_data = data['Data'];
          this.FollowUpList.forEach(element => {
            let name = JSON.parse(element.customer);
            element.customer_name = name[0].Customer_Name || '';
            // element.cif = name[0].cif || '';
            element.agent_name = name[0].AGENT;
          });


          console.log(this.FollowUpList, '12345');
          if (this.agent_search) {
            this.FollowUpList = this.FollowUpList.filter((ele: any) =>
              ele.agent_name.toUpperCase() == this.agent_search.toUpperCase()
            )
          }
          console.log(this.FollowUpList, 'FollowUpList');
        } else {
          this.FollowUpList = [];
          this.temp_data = [];
        }


      });
    } else if (this.ptp_start_date == '' && this.ptp_end_date == '' && this.agent_search == '') {
      alert("select filter value");
    }

    // let latest_date =this.datepipe.transform(this.date_search, 'yyyy-MM-dd');
    // console.log(latest_date);
    // this.userFilter.log_date = latest_date;
    // this.userFilter.agent_name = this.agent_search;

  }

  clear() {
    this.FollowUpList = [];;
    this.date_search = '';
    this.agent_search = null;
    this.ptp_start_date = '';
    this.ptp_end_date = '';
    this.CustumDtails = [];
    this.Report_CustDetials = [];
    this.settlementAndPaymentList = [];
    this.settlementList = [];
    this.fieldVisitReportList = [];
    this.baseReportBankList = [];
    this.shortBaseReportList = [];
  }







  prevpay() {
    this.payment_skip = this.payment_skip - 10;
    this.search();
  }

  nextpay() {
    this.payment_skip = this.payment_skip + 10;
    this.search();
  }

  payment_datesearch() {
    this.startTimer();
    if (this.payment_start_date == '' && this.payment_end_date !== '') {
      alert("select start date");
    }
    else if (this.payment_start_date !== '' && this.payment_end_date == '') {
      alert("select end date");
    }
    else if (this.payment_start_date == '' && this.payment_end_date == '' && this.payment_text_search !== "") {

      let c = {
        bank_id: this.bankid,
        bucket_id: this.bucketid || "",
        portfolio_id: this.portfolioid,
        text_search: this.payment_text_search,
        // filter:true
      }
      this._api.getPaymentsReport_textsearch(c).subscribe(data => {
        if (data['Code'] == 200) {
          this.PaymentsList = data['Data'];
          this.payment_count = data['payment_count'];
          // console.log(this.payment_count);
          this.PaymentsList.forEach(element => {
            if (element.customer.customer_details[0].Customer_Name == undefined) {
              let name = JSON.parse(element.customer.customer_details[0]);
              element.customer_name = name[0].Customer_Name || '';
            } else {
              element.customer_name = element.customer.customer_details[0].Customer_Name || '';
            }
          });
        } else {
          this.PaymentsList = [];
        }
      });
    }
    else if (this.payment_start_date !== '' && this.payment_end_date !== '' && this.payment_text_search == "") {

      let c = {
        bank_id: this.bankid,
        bucket_id: this.bucketid || "",
        portfolio_id: this.portfolioid,
        date_search: this.payment_date_search,
        start_date: this.payment_start_date,
        end_date: this.payment_end_date,
      }
      this._api.getPaymentsReport_datesearch(c).subscribe(data => {
        if (data['Code'] == 200) {
          this.PaymentsList = data['Data'];
          this.payment_count = data['payment_count'];
          // console.log(this.payment_count);
          this.PaymentsList.forEach(element => {
            if (element.customer.customer_details[0].Customer_Name == undefined) {
              let name = JSON.parse(element.customer.customer_details[0]);
              element.customer_name = name[0].Customer_Name || '';
            } else {
              element.customer_name = element.customer.customer_details[0].Customer_Name || '';
            }
          });
        } else {
          this.PaymentsList = [];
        }
      });
    }
    else if (this.payment_start_date !== '' && this.payment_end_date !== '' && this.payment_text_search !== "") {

      let c = {
        bank_id: this.bankid,
        bucket_id: this.bucketid || "",
        portfolio_id: this.portfolioid,
        date_search: this.payment_date_search,
        text_search: this.payment_text_search,

      }
      this._api.getPaymentsReport_textdatesearch(c).subscribe(data => {
        if (data['Code'] == 200) {
          this.PaymentsList = data['Data'];
          this.payment_count = data['payment_count'];
          // console.log(this.PaymentsList, '1234560');
          this.PaymentsList.forEach(element => {
            if (element.customer.customer_details[0].Customer_Name == undefined) {
              let name = JSON.parse(element.customer.customer_details[0]);
              element.customer_name = name[0].Customer_Name || '';
              element.agent_name = name[0].AGENT || '';
            } else {
              element.customer_name = element.customer.customer_details[0].Customer_Name || '';
              element.agent_name = element.customer.customer_details[0].AGENT || '';
            }

          });

          if (this.payment_text_search) {
            this.PaymentsList = this.PaymentsList.filter((ele: any) =>
              ele.agent_name.toUpperCase() == this.payment_text_search.toUpperCase()
            )
          }
          console.log(this.PaymentsList, '12345');
        } else {
          this.PaymentsList = [];
        }
      });
    } else if (this.payment_start_date == '' && this.payment_end_date == '' && this.payment_text_search == "") {
      alert("select filter value");
    }
  }

  payment_clear() {
    this.payment_text_search = '';
    this.payment_date_search = '';
    this.payment_end_date = '';
    this.payment_start_date = '';
    this.search();
    // this.startTimer();
    this.PaymentsList = [];
  }

  startTimer() {
    this.show_loader = true;
    this.interval = setInterval(() => {
      if (this.timeLeft > 0) {
        this.timeLeft--;
        // console.log(this.timeLeft);
        this.show_loader = true;
      } else {
        this.pauseTimer();
      }
    }, 1000)
  }

  pauseTimer() {
    this.show_loader = false;
    clearInterval(this.interval);
    this.timeLeft = 5;
  }



  filterFeedback() {
    if (this.ptp_start_date == '' && this.ptp_end_date !== '') {
      alert("select start date");
    } else if (this.ptp_start_date !== '' && this.ptp_end_date == '') {
      alert("select end date");
    } else if (this.ptp_start_date !== '' && this.ptp_end_date !== '') {
      let dataFormat = {
        bank_id: this.bankid,
        bucket_id: this.bucketid || "",
        portfolio_id: this.portfolioid ? this.portfolioid : null,
        product_id: "1",
        skip: this.payment_skip,
        count: 10,
        bank_name: this.bank_name,
        portfolio_type: this.portfolioid,
        agent_name: this.agent_search,
        sdate: this.ptp_start_date,
        edate: this.ptp_end_date,
        filter: true,
      };

      this._api.getFollowUpReport_CustDetials(dataFormat).subscribe(data => {
        this.CustumDtails = data['Data'];
        console.log("this.CustumDtails", this.CustumDtails);

        this.CustumDtails = this.CustumDtails.filter((ele: any) =>
          ele.remarks.length != 0
        );

        console.log("this.CustumDtails1", this.CustumDtails);
        this.temp_data = data['Data'];

        this.CustumDtails.forEach((element: any) => {
          console.log("343245320", element.customer_details);

          var tempDetail = element.customer_details.customer_details? element.customer_details.customer_details[0] : [];
          let name = tempDetail ? JSON.parse(tempDetail) : null;
         if (name != null) {
          console.log("name",name);

          element.customer_name = name && name[0].Customer_Name ? name[0].Customer_Name : '';
          element.cif = name && name[0].cif ? name[0].cif : '';
          element.total_out_standing = name && name[0][' total_out_standing '] ? name[0][' total_out_standing '] : name[0].total_out_standing;
          element.agent_name = name && name[0].AGENT ? name[0].AGENT : '';
          element.acc_no = name && name[0].acc_no ? name[0].acc_no : element.customer_details? element.customer_details.acc_no:'';

          element.remarks.sort((a: any, b: any) => {
            const dateA = new Date(a.createdAt);
            const dateB = new Date(b.createdAt);
            return dateA.getTime() - dateB.getTime();
          });
          element.mstatus.sort((a: any, b: any) => {
            const dateA = new Date(a.createdAt);
            const dateB = new Date(b.createdAt);
            return dateA.getTime() - dateB.getTime();
          });
          var createdAt = element.remarks[element.remarks.length - 1].createdAt;
          const createdAtString = new Date(createdAt);
          var dateOnlye = createdAtString.toISOString().substring(0, 10);
          element.createdAtString = dateOnlye;
          console.log("element.createdAtString", element.createdAtString);

          var Log_date = element.remarks[element.remarks.length - 1].log_date;
          const Log_dateString = new Date(Log_date);
          var dateOnly = Log_dateString.toISOString().substring(0, 10);
          element.Log_dateString = dateOnly;
          console.log("element.Log_dateString", element.Log_dateString);

          setTimeout(() => {
            if (this.agent_search) {
              this.CustumDtails = this.CustumDtails.filter((ele: any) =>
                ele.agent_name.toLowerCase() == this.agent_search.toLowerCase()
              );
            }
          });

         }
        });

        console.log("CustumDtails", this.CustumDtails);
      });
    }
  }



  filterAllocation() {
    this.startTimer();
    if (this.ptp_start_date == '' && this.ptp_end_date !== '') {
      alert("select start date");
    }
    else if (this.ptp_start_date !== '' && this.ptp_end_date == '') {
      alert("select end date");
    }
    else if (this.ptp_start_date !== '' && this.ptp_end_date !== '') {

      // debugger
      let dataFormat = {
        bank_id: this.bankid,
        bucket_id: this.bucketid || "",
        portfolio_id: this.portfolioid ? this.portfolioid : null,
        // product_id: "1",
        // skip: this.payment_skip,
        count: 10,
        bank_name: this.bank_name,
        portfolio_type: this.portfolioid,
        // agent_name: this.agent_search,
        sdate: this.ptp_start_date,
        edate: this.ptp_end_date,
        filter: true
      };


      this._api.getFollowUpReport_AlacationDetails(dataFormat).subscribe(data => {
        //  debugger
        this.Report_CustDetials = data['Data'];
        // console.log("CustumDtails",this.CustumDtails);
        this.temp_data = data['Data'];
        this.Report_CustDetials.forEach(element => {
          if (element.customer_details && element.customer_details.length == 1) {
            var tempDetail = element.customer_details ? element.customer_details[0] : [];
            let name = tempDetail ? JSON.parse(tempDetail) : null;
            element.customer_name = name && name[0].Customer_Name ? name[0].Customer_Name : '';
            element.cif = name && name[0].cif ? name[0].cif : '';
            element.total_out_standing = name && name[0][' total_out_standing '] ? name[0][' total_out_standing '] :name[0].total_out_standing;
            element.agent_name = name && name[0].AGENT ? name[0].AGENT : '';
          }

          var text = element.date_of_allocations;

          const dateString =new Date(text);
          var dateOnly = dateString.toISOString().substring(0, 10); // Returns the date in the local date format
          element.date_of_allocations = dateOnly
          // console.log("dateOnly", element.date_of_allocations);


          // setTimeout(() => {                           // <<<---using ()=> syntax
          //   if (this.agent_search) {
          //     this.Report_CustDetials = this.Report_CustDetials.filter((ele: any) =>{
          //       ele.agent_name.toLowerCase() == this.agent_search.toLowerCase()
          //   })
          //   }
          // }, 3000);

          setTimeout(() => {
            if (this.agent_search) {
              this.Report_CustDetials = this.Report_CustDetials.filter((ele: any) => {
                if (ele.agent_name && typeof ele.agent_name === "string") {
                  return ele.agent_name.toLowerCase() === this.agent_search.toLowerCase();
                }
              });
            }
          }, 3000);


        });
        console.log("Report_CustDetials", this.Report_CustDetials);
        //   setTimeout(()=>{                           // <<<---using ()=> syntax
        //    if(this.agent_search){
        //     var arr=[];
        //     this.CustumDtails.forEach(element => {
        //       if(element.AGENT == this.agent_search){
        //         arr.push(element)
        //       }

        //     });

        //     this.CustumDtails = arr;
        //    }
        // }, 3000);

        // console.log("Report_CustDetials",this.Report_CustDetials);


      });

    }
  }


  settlementreport() {

    if (this.ptp_start_date == '' && this.ptp_end_date !== '') {
      alert("select start date");
    }
    else if (this.ptp_start_date !== '' && this.ptp_end_date == '') {
      alert("select end date");
    }
    else if (this.ptp_start_date !== '' && this.ptp_end_date !== '') {

      // debugger
      let dataFormat = {
        bank_id: this.bankid,
        bucket_id: this.bucketid || "",
        portfolio_id: this.portfolioid ? this.portfolioid : null,
        product_id: "1",
        skip: this.payment_skip,
        count: 10,
        portfolio_type: this.portfolioid,
        // agent_name: this.agent_search,
        sdate: this.ptp_start_date,
        edate: this.ptp_end_date,
        filter: true,
        remarks: this.remarks
      };

      this._api.SettlementReport(dataFormat).subscribe(data => {
        if (data['Code'] == 200) {
          this.settlementList = data['Data'];
          // this.doStuff();

          this.settlementList.forEach(element => {

            console.log(element.customer_name.customer_details[0], "test1");

            let name = JSON.parse(element.customer_name.customer_details[0]);
            element.cif = name[0].cif;
            // element.agent_name = name[0].AGENT;

          });


          console.log(this.settlementList, '12345');
          if (this.agent_search) {
            this.settlementList = this.settlementList.filter((ele: any) =>
              ele.agent_name.toUpperCase() == this.agent_search.toUpperCase()
            )
          }
          console.log(this.settlementList, 'FollowUpList');
        } else {
          this.settlementList = [];
          this.temp_data = [];
        }
      });
    }
  }


  settlementPamentReport() {
    if (this.ptp_start_date == '' && this.ptp_end_date !== '') {
      alert("select start date");
    }
    else if (this.ptp_start_date !== '' && this.ptp_end_date == '') {
      alert("select end date");
    }
    else if (this.ptp_start_date !== '' && this.ptp_end_date !== '') {

      // debugger
      let dataFormat = {
        bank_id: this.bankid,
        bucket_id: this.bucketid || "",
        portfolio_id: this.portfolioid ? this.portfolioid : null,
        product_id: "1",
        skip: this.payment_skip,
        count: 10,
        bank_name: this.bank_name,
        portfolio_type: this.portfolioid,
        // agent_name: this.agent_search,
        sdate: this.ptp_start_date,
        edate: this.ptp_end_date,
        filter: true,
        remarks: this.remarks
      };


      this._api.newSettlementAnd_bank_List_report(dataFormat).subscribe(data => {
        if (data['Code'] == 200) {
          this.settlementAndPaymentList = data['Data'];

          this.settlementAndPaymentList.forEach(element => {

            let name = JSON.parse(element.customer_name);

            element.agent_name = name[0].AGENT;
            element.cif = name[0].cif;
            element.createdAt = name && name.createdAt ? name.createdAt : '';
          });
          // this.AgentSpitFunAndJSONparse();

          console.log("settlementAndPaymentList", this.settlementAndPaymentList);

        }
      });
    }
  }

  yourFn(event) {

    let dataFormat = {
      bank_id: this.bankid,
      bucket_id: this.bucketid || "",
      portfolio_id: this.portfolioid ? this.portfolioid : null,
      product_id: "1",
      skip: this.payment_skip,
      count: 10,
      bank_name: this.bank_name,
      portfolio_type: this.portfolioid,
      agent_name: this.agent_search,
      sdate: this.start_date,
      edate: this.end_date,
      filter: true
    };







    // if (event.tab.textLabel == "Settlement Reports") {
    //   this._api.SettlementReport(dataFormat).subscribe(data => {
    //     if (data['Code'] == 200) {
    //       this.settlementList = data['Data'];
    //       this.doStuff();
    //     }
    //   });
    // }
    // if (event.tab.textLabel == "Settlements / Payments Reports") {
    //   this._api.newSettlementAnd_bank_List_report(dataFormat).subscribe(data => {
    //     if (data['Code'] == 200) {
    //       this.settlementAndPaymentList = data['Data'];

    //       this.CustumDtails.forEach(element => {
    //         if(element.settlementAndPaymentList && element.settlementAndPaymentList.length == 1){
    //           var tempDetail = element.settlementAndPaymentList?element.settlementAndPaymentList[0]:[];
    //           let name = tempDetail ? JSON.parse(tempDetail) :null;
    //           element.customer_name = name && name[0].Customer_Name ? name[0].Customer_Name :'';
    //           element.cif = name && name[0].cif ? name[0].cif :'';
    //           element.total_out_standing = name && name[0][' total_out_standing '] ? name[0][' total_out_standing '] :'';

    //           // element.agent_name = element.createdby.name;
    //         }
    //         });
    //       this.AgentSpitFunAndJSONparse();
    //     }
    //   });
    // }

    // if (event.tab.textLabel == "Short Base Report") {
    //   this._api.shortBaseReport(dataFormat).subscribe(data => {
    //     if (data['Code'] == 200) {
    //       this.shortBaseReportList = data['Data'];

    //       this.shortBaseReportList.forEach(element => {
    //         if(element.customer_details && element.customer_details.length == 1){
    //           var tempDetail = element.customer_details?element.customer_details[0]:[];
    //           let name = tempDetail ? JSON.parse(tempDetail) :null;
    //           element.customer_name = name && name[0].Customer_Name ? name[0].Customer_Name :'';
    //           element.cif = name && name[0].cif ? name[0].cif :'';
    //           element.total_out_standing = name && name[0][' total_out_standing '] ? name[0][' total_out_standing '] :'';
    //           element.agent_name = name && name[0].AGENT ? name[0].AGENT :'';
    //           element.emirates_id = name && name[0]['EMIRATES ID'] ? name[0]['EMIRATES ID']:'';
    //         }

    //       });
    //       console.log("shortBaseReport",this.shortBaseReportList)
    //       // this.ShortBaseJSONparse();
    //     }
    //   });
    // }
    // if (event.tab.textLabel == "Base Report Bank") {
    //   this._api.baseReportBank(dataFormat).subscribe(data => {
    //     if (data['Code'] == 200) {
    //       this.baseReportBankList = data['Data'];
    //       this.baseReportBankList.forEach(element => {
    //         if(element.customer_details && element.customer_details.length == 1){
    //           var tempDetail = element.customer_details?element.customer_details[0]:[];
    //           let name = tempDetail ? JSON.parse(tempDetail) :null;
    //           element.customer_name = name && name[0].Customer_Name ? name[0].Customer_Name :'';
    //           element.cif = name && name[0].cif ? name[0].cif :'';
    //           element.total_out_standing = name && name[0][' total_out_standing '] ? name[0][' total_out_standing '] :'';
    //           element.agent_name = name && name[0].AGENT ? name[0].AGENT :'';
    //           element.emirates_id = name && name[0]['EMIRATES ID'] ? name[0]['EMIRATES ID']:'';
    //         }
    //         if(this.payment_text_search){
    //           this.baseReportBankList = this.baseReportBankList.filter((ele:any)=>
    //             ele.agent_name == this.payment_text_search
    //           )
    //         }
    //       });
    //       console.log("shortBaseReport",this.baseReportBankList)
    //       this.BaseReportBankJSONparse();
    //     }
    //   });
    // }
    // if (event.tab.textLabel == "Field Visit Reports") {
    //   this._api.fieldVisitReport(dataFormat).subscribe(data => {
    //     if (data['Code'] == 200) {
    //       this.fieldVisitReportList = data['Data'];
    //       console.log("fieldVisitReportList",this.fieldVisitReportList)
    //       // this.FieldVisitJSONparse();
    //     }
    //   });
    // }


  }

  FieldVisitJSONparse() {
    this.fieldVisitReportList && this.fieldVisitReportList.forEach(async element => {
      await this.example1(element);
    });
    console.log("The End");
    console.log("this.fieldVisitReportList", this.fieldVisitReportList);
  };


  BaseReportBankJSONparse() {
    this.baseReportBankList && this.baseReportBankList.forEach(async element => {
      await this.JSONparsefun3(element);
    });
    console.log("this.baseReportBankList", this.baseReportBankList);
  }

  ShortBaseJSONparse() {
    this.shortBaseReportList && this.shortBaseReportList.forEach(async element => {
      await this.JSONparsefun3(element);
    });
    console.log("this.shortBaseReportList", this.shortBaseReportList);
  }

  JSONparsefun3(element) {
    new Promise(function (resolve, reject) {
      setTimeout(function () {

        if (element?.customer_details) {
          var test1 = element?.customer_details[0];
          var test2 = JSON.parse(element?.customer_details);
          element.cust = test2;
        }
        resolve('foo1');
      },);
    });
  }


  JSONparsefun2(element) {
    new Promise(function (resolve, reject) {
      setTimeout(function () {

        if (element.customer_name && element.customer_name.customer_details) {
          var test1 = element.customer_name.customer_details[0];
          var test2 = JSON.parse(test1);
          element.cust = test2;
        }
        resolve('foo1');
      }, 500);
    });
  }




  AgentSpitFunAndJSONparse() {
    this.settlementAndPaymentList && this.settlementAndPaymentList.forEach(async element => {
      await this.JSONparsefun2(element);
    });
    // console.log("The End");
    // console.log("this.settlementAndPaymentList", this.settlementAndPaymentList);
  };

  AgentSpitFunAndJSONparse2() {
    this.CustumDtails && this.CustumDtails.forEach(async element => {
      await this.JSONparsefun2(element);
    });
    // console.log("The End");
    // console.log("this.settlementAndPaymentList", this.settlementAndPaymentList);
  };



  example1(element) {
    new Promise(function (resolve, reject) {
      setTimeout(function () {

        if (element.customer_name && element.customer_name.customer_details) {
          var test1 = element.customer_name.customer_details[0];
          var test2 = JSON.parse(test1);
          element.cust = test2;
        }
        resolve('foo1');
      }, 500);
    });
  }




  doStuff() {
    this.settlementList && this.settlementList.forEach(async element => {
      await this.example1(element);
    });
    console.log("The End");
    console.log("this.settlementList", this.settlementList);
  };
  doStuff2() {
    this.CustumDtails && this.CustumDtails.forEach(async element => {
      await this.example1(element);
    });
    console.log("The End");
    console.log("this.settlementList", this.CustumDtails);
  };

  fieldVisitRReportSearch() {
    const dataFormat = {
      bank_id: this.bankid,
      bucket_id: this.bucketid || "",
      portfolio_id: this.portfolioid,
      product_id: "1",
      skip: this.payment_skip,
      count: 10,
      filter: true,
      sdate: this.payment_start_date,
      edate: this.payment_end_date,
      payment_text_search: this.payment_text_search
    };

    console.log(this.payment_start_date);
    console.log(this.payment_end_date);
    console.log(this.payment_text_search);

    this._api.fieldVisitReport(dataFormat).subscribe(data => {
      if (data['Code'] == 200) {
        // debugger
        this.fieldVisitReportList = data['Data'];


        // console.log("fieldVisitReportList",this.fieldVisitReportList);
        setTimeout(() => {
          this.fieldVisitReportList.forEach(element => {
            let name = JSON.parse(element.customer_name.customer_details[0],);
            element.agent_name = name[0].AGENT;
            element.Customer_Name = name[0].Customer_Name;
            // console.log("fieldVisitReportList",this.fieldVisitReportList);

          });

          if (this.payment_text_search) {
            this.fieldVisitReportList = this.fieldVisitReportList.filter((ele: any) =>
              ele.agent_name.toUpperCase() == this.payment_text_search.toUpperCase()

            )
          }
        });
        console.log(this.fieldVisitReportList, 'FollowUpList');
      }
      else {
        this.fieldVisitReportList = []
      }


    });

  }


  shortBaseReportSearch() {
    const dataFormat = {
      bank_id: this.bankid,
      bucket_id: this.bucketid || "",
      portfolio_id: this.portfolioid,
      product_id: "1",
      skip: this.payment_skip,
      count: 10,
      filter: true,
      sdate: this.payment_start_date,
      edate: this.payment_end_date,
      payment_text_search: this.payment_text_search
    };

    this._api.shortBaseReport(dataFormat).subscribe(data => {
      if (data['Code'] == 200) {
        this.shortBaseReportList = data['Data'];


        this.shortBaseReportList.forEach(element => {
          if (element.customer_details && element.customer_details.length == 1) {
            var tempDetail = element.customer_details ? element.customer_details[0] : [];
            let name = tempDetail ? JSON.parse(tempDetail) : null;
            element.customer_name = name && name[0].Customer_Name ? name[0].Customer_Name : '';
            element.cif = name && name[0].cif ? name[0].cif : '';
            element.total_out_standing = name && name[0][' total_out_standing '] ? name[0][' total_out_standing '] : '';
            element.agent_name = name && name[0].AGENT ? name[0].AGENT : '';
            element.emirates_id = name && name[0]['EMIRATES ID'] ? name[0]['EMIRATES ID'] : '';
          }
          setTimeout(() => {
            if (this.payment_text_search) {
              this.shortBaseReportList = this.shortBaseReportList.filter((ele: any) =>
                ele.agent_name.toUpperCase() == this.payment_text_search.toUpperCase()

              )
            }
          });

        });
        this.ShortBaseJSONparse();
      }
    });
  }

  baseReportBankSearch() {
    const dataFormat = {
      bank_id: this.bankid,
      bucket_id: this.bucketid || "",
      portfolio_id: this.portfolioid,
      product_id: "1",
      skip: this.payment_skip,
      count: 10,
      filter: true,
      sdate: this.payment_start_date,
      edate: this.payment_end_date,
      payment_text_search: this.payment_text_search
    };

    this._api.baseReportBank(dataFormat).subscribe(data => {
      if (data['Code'] == 200) {
        this.baseReportBankList = data['Data'];
        this.baseReportBankList.forEach(element => {
          if (element.customer_details && element.customer_details.length == 1) {
            var tempDetail = element.customer_details ? element.customer_details[0] : [];
            let name = tempDetail ? JSON.parse(tempDetail) : null;
            element.customer_name = name && name[0].Customer_Name ? name[0].Customer_Name : '';
            element.cif = name && name[0].cif ? name[0].cif : '';
            element.total_out_standing = name && name[0][' total_out_standing '] ? name[0][' total_out_standing '] : '';
            element.agent_name = name && name[0].AGENT ? name[0].AGENT : '';
            element.emirates_id = name && name[0]['EMIRATES ID'] ? name[0]['EMIRATES ID'] : '';
          }
          setTimeout(() => {
            if (this.payment_text_search) {
              this.baseReportBankList = this.baseReportBankList.filter((ele: any) =>
                ele.agent_name.toUpperCase() == this.payment_text_search.toUpperCase()
              )
            }
          });
          // console.log("shortBaseReport",this.baseReportBankList)
        });
        // this.BaseReportBankJSONparse();

      }
    });
  }
  SettlementRepSubSearch() {
    // debugger;

    // console.log(this.payment_start_date);
    // console.log(this.payment_end_date);
    // console.log(this.payment_text_search);

    const dataFormat = {
      bank_id: this.bankid,
      bucket_id: this.bucketid || "",
      portfolio_id: this.portfolioid,
      product_id: "1",
      skip: this.payment_skip,
      count: 10,
      filter: true,
      sdate: this.payment_start_date,
      edate: this.payment_end_date,
      payment_text_search: this.payment_text_search
    };

    console.log(dataFormat);


    this._api.SettlementReport(dataFormat).subscribe(data => {
      if (data['Code'] == 200) {
        this.settlementList = data['Data'];

        this.settlementList.forEach(element => {
          let name = JSON.parse(element.customer_name.customer_details[0],);
          element.agent_name = name[0].AGENT;
          element.cif = name[0].cif;
          element.Customer_Name = name[0].Customer_Name;
        });
        console.log(this.settlementList, '12345');
        if (this.agent_search) {
          this.settlementList = this.settlementList.filter((ele: any) =>
            ele.agent_name.toUpperCase() == this.agent_search.toUpperCase()
          )
        }
        console.log(this.settlementList, 'FollowUpList');


      }
    });
  }

  SettlementPaymentListSearch() {
    // debugger;

    // console.log(this.payment_start_date);
    // console.log(this.payment_end_date);
    // console.log(this.payment_text_search);

    const dataFormat = {
      bank_id: this.bankid,
      bucket_id: this.bucketid || "",
      portfolio_id: this.portfolioid,
      product_id: "1",
      skip: this.payment_skip,
      count: 10,
      filter: true,
      sdate: this.payment_start_date,
      edate: this.payment_end_date,
      // payment_text_search:this.payment_text_search
    };

    console.log(dataFormat);


    this._api.newSettlementAnd_bank_List_report(dataFormat).subscribe(data => {
      if (data['Code'] == 200) {
        this.settlementAndPaymentList = data['Data'];

        this.settlementAndPaymentList.forEach(element => {
          let name = JSON.parse(element.customer_name.customer_details[0],);
          element.agent_name = name[0].AGENT;
          element.Customer_Name = name[0].Customer_Name;

          element.cif = name[0].cif;
          var text = element.customer_name;
          element.createdAt = text.createdAt;
          element.updatedAt = text.updatedAt;
        });

        if (this.payment_text_search) {
          this.settlementAndPaymentList = this.settlementAndPaymentList.filter((ele: any) =>
            ele.agent_name.toUpperCase() == this.payment_text_search.toUpperCase()
          )

          console.log(this.settlementAndPaymentList, '12345');
        }
      }
    });
  }





  SettlementClear() {
    const dataFormat = {
      bank_id: this.bankid,
      bucket_id: this.bucketid || "",
      portfolio_id: this.portfolioid,
      product_id: "1",
      skip: this.payment_skip,
      count: 10,
    };

    console.log(dataFormat);


    this._api.SettlementReport(dataFormat).subscribe(data => {
      if (data['Code'] == 200) {
        this.settlementList = data['Data'];

        setTimeout(function () {

        }, 10000);

      }
    });
  }

  // sort(field: string) {
  //   const sortOrder = this.Report_CustDetials.length > 1 && this.Report_CustDetials[0][field] < this.Report_CustDetials[1][field] ? -1 : 1;
  //   this.Report_CustDetials.sort((a, b) => {
  //     const aVal = a[field];
  //     const bVal = b[field];
  //     return sortOrder * (aVal < bVal ? -1 : aVal > bVal ? 1 : 0);
  //   });
  // }




  sort(field: string) {
    if (field === this.sortField) {
      this.sortOrder = this.sortOrder === 'asc' ? 'desc' : 'asc';
    } else {
      this.sortField = field;
      this.sortOrder = 'asc';
    }

    this.sortIconClass = this.sortOrder === 'asc' ? 'fa-sort-asc' : 'fa-sort-desc';

    if (this.Report_CustDetials = this.Report_CustDetials || []) {

      this.Report_CustDetials.sort((a, b) => {
        const aVal = a[field];
        const bVal = b[field];
        return this.sortOrder === 'asc' ? (aVal < bVal ? -1 : aVal > bVal ? 1 : 0) : (aVal > bVal ? -1 : aVal < bVal ? 1 : 0);
      });
    }
  }
  sort1(field: string) {
    if (field === this.sortField) {
      this.sortOrder = this.sortOrder === 'asc' ? 'desc' : 'asc';
    } else {
      this.sortField = field;
      this.sortOrder = 'asc';
    }

    this.sortIconClass = this.sortOrder === 'asc' ? 'fa-sort-asc' : 'fa-sort-desc';

    if (this.settlementAndPaymentList = this.settlementAndPaymentList || []) {
      this.settlementAndPaymentList.sort((a, b) => {
        const aVal = a[field];
        const bVal = b[field];
        return this.sortOrder === 'asc' ? (aVal < bVal ? -1 : aVal > bVal ? 1 : 0) : (aVal > bVal ? -1 : aVal < bVal ? 1 : 0);
      });
    }
  }

  sort2(field: string) {
    if (field === this.sortField) {
      this.sortOrder = this.sortOrder === 'asc' ? 'desc' : 'asc';
    } else {
      this.sortField = field;
      this.sortOrder = 'asc';
    }

    this.sortIconClass = this.sortOrder === 'asc' ? 'fa-sort-asc' : 'fa-sort-desc';


    if (this.settlementList = this.settlementList || []) {
      this.settlementList.sort((a, b) => {
        const aVal = a[field];
        const bVal = b[field];
        return this.sortOrder === 'asc' ? (aVal < bVal ? -1 : aVal > bVal ? 1 : 0) : (aVal > bVal ? -1 : aVal < bVal ? 1 : 0);
      });
    }
  }

  sort3(field: string) {
    if (field === this.sortField) {
      this.sortOrder = this.sortOrder === 'asc' ? 'desc' : 'asc';
    } else {
      this.sortField = field;
      this.sortOrder = 'asc';
    }

    this.sortIconClass = this.sortOrder === 'asc' ? 'fa-sort-asc' : 'fa-sort-desc';


    if (this.shortBaseReportList = this.shortBaseReportList || []) {
      this.shortBaseReportList.sort((a, b) => {
        const aVal = a[field];
        const bVal = b[field];
        return this.sortOrder === 'asc' ? (aVal < bVal ? -1 : aVal > bVal ? 1 : 0) : (aVal > bVal ? -1 : aVal < bVal ? 1 : 0);
      });
    }
  }
  sort4(field: string) {
    if (field === this.sortField) {
      this.sortOrder = this.sortOrder === 'asc' ? 'desc' : 'asc';
    } else {
      this.sortField = field;
      this.sortOrder = 'asc';
    }

    this.sortIconClass = this.sortOrder === 'asc' ? 'fa-sort-asc' : 'fa-sort-desc';

    if (this.baseReportBankList = this.baseReportBankList || []) {
      this.baseReportBankList.sort((a, b) => {
        const aVal = a[field];
        const bVal = b[field];
        return this.sortOrder === 'asc' ? (aVal < bVal ? -1 : aVal > bVal ? 1 : 0) : (aVal > bVal ? -1 : aVal < bVal ? 1 : 0);
      });
    }
  }

  sort5(field: string) {
    if (field === this.sortField) {
      this.sortOrder = this.sortOrder === 'asc' ? 'desc' : 'asc';
    } else {
      this.sortField = field;
      this.sortOrder = 'asc';
    }

    this.sortIconClass = this.sortOrder === 'asc' ? 'fa-sort-asc' : 'fa-sort-desc';


    if (this.PaymentsList = this.PaymentsList || []) {
      this.PaymentsList.sort((a, b) => {
        const aVal = a[field];
        const bVal = b[field];
        return this.sortOrder === 'asc' ? (aVal < bVal ? -1 : aVal > bVal ? 1 : 0) : (aVal > bVal ? -1 : aVal < bVal ? 1 : 0);
      });
    }
  }
  sort6(field: string) {
    if (field === this.sortField) {
      this.sortOrder = this.sortOrder === 'asc' ? 'desc' : 'asc';
    } else {
      this.sortField = field;
      this.sortOrder = 'asc';
    }

    this.sortIconClass = this.sortOrder === 'asc' ? 'fa-sort-asc' : 'fa-sort-desc';

    if (this.Report_CustDetials = this.Report_CustDetials || []) {
      this.fieldVisitReportList.sort((a, b) => {
        const aVal = a[field];
        const bVal = b[field];
        return this.sortOrder === 'asc' ? (aVal < bVal ? -1 : aVal > bVal ? 1 : 0) : (aVal > bVal ? -1 : aVal < bVal ? 1 : 0);
      });
    }
  }
  sort7(field: string) {
    if (field === this.sortField) {
      this.sortOrder = this.sortOrder === 'asc' ? 'desc' : 'asc';
    } else {
      this.sortField = field;
      this.sortOrder = 'asc';
    }

    this.sortIconClass = this.sortOrder === 'asc' ? 'fa-sort-asc' : 'fa-sort-desc';

    if (this.FollowUpList = this.FollowUpList || []) {
      this.FollowUpList.sort((a, b) => {
        const aVal = a[field];
        const bVal = b[field];
        return this.sortOrder === 'asc' ? (aVal < bVal ? -1 : aVal > bVal ? 1 : 0) : (aVal > bVal ? -1 : aVal < bVal ? 1 : 0);
      });
    }
  }

  sort8(field: string) {
    if (field === this.sortField) {
      this.sortOrder = this.sortOrder === 'asc' ? 'desc' : 'asc';
    } else {
      this.sortField = field;
      this.sortOrder = 'asc';
    }

    this.sortIconClass = this.sortOrder === 'asc' ? 'fa-sort-asc' : 'fa-sort-desc';

    if (this.CustumDtails = this.CustumDtails || []) {
      this.CustumDtails.sort((a, b) => {
        const aVal = a[field];
        const bVal = b[field];
        return this.sortOrder === 'asc' ? (aVal < bVal ? -1 : aVal > bVal ? 1 : 0) : (aVal > bVal ? -1 : aVal < bVal ? 1 : 0);
      });
    }
  }






}
